<style src="@/assets/styles/utils/tooltip.styl" lang="stylus"></style>
<template>
  <div class="cb-cart cb-cart--multiple cb-cart--footer">
    <div v-if="discountPresent" class="cb-item--extras cb-transition__fade">
      <div class="cb-item__name">
        {{ consolidated_discount.title }}
        <div class="tooltip" v-if="isManualDiscount(consolidated_discount)">
          <i class="icon-info-circle cb-notebar__muted info"></i>
          <span class="tooltiptext" v-cb-html="getDiscountTooltipMessage"></span>
        </div>
        <div
          @click="removeDiscount(consolidated_discount.coupon_id)"
          v-cb-link="'color'"
          class="cb-item__action cb-extras__action"
          v-if="coupon_enabled && consolidated_discount.coupon_id && !readonly && !isManualDiscount(consolidated_discount)"
        >
          {{ ct("cart.remove") }}
        </div>
      </div>
      <div class="cb-item__deduction">
        {{ consolidated_discount.amount | cbCurrency(currency_code, true) }}
      </div>
    </div>
    <div v-if="total_credits > 0" class="cb-item--extras">
      <div class="cb-item__name">{{ ct("credits_applied.label") }}</div>
      <div class="cb-item__deduction">
        {{ total_credits | cbCurrency(currency_code, true) }}
      </div>
    </div>
    <!-- Exclusive taxes -->
    <div v-if="consolidated_tax && is_tax_exclusive" class="cb-item--extras">
      <div class="cb-item__name">{{ consolidated_tax.title }}</div>
      <div class="cb-item__deduction">
        {{ consolidated_tax.amount | cbCurrency(currency_code) }}
      </div>
    </div>
    <div class="cb-item__total">
      {{ (amount_due || 0) | cbCurrency(currency_code) }}
    </div>
    <!-- Inclusive taxes -->
    <div class="cb-item" v-if="consolidated_tax && is_tax_inclusive">
      <div class="cb-item__name">
        {{ cmt("included_tax_group.txt") }} {{ consolidated_tax.title }} :
        {{ consolidated_tax.amount | cbCurrency(currency_code) }}
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex";
import CartHelper from "@/utils/cart-helper";
import CartMixin from "@/mixins/cart-mixin";
import ItemDescription from "@/components/modules/hosted-pages/ItemDescription";
import MultiDecimalHelper from "@/utils/multi-decimal";
import HostedPageHelper from '@/utils/hosted-page-helper'

export default {
  props: ["estimate", "readonly"],
  mixins: [CartMixin],
  components: {
    "item-description": ItemDescription,
  },
  computed: {
    ...mapGetters(["currency_code", "coupon_enabled", "is_checkout_one_time"]),
    consolidated_discount() {
      return CartHelper._discounts(this.estimate.discounts || []);
    },
    discountPresent() {
      return !!this.consolidated_discount;
    },
    consolidated_tax() {
      return CartHelper._taxes(this.estimate.taxes || []);
    },
    is_tax_exclusive() {
      return this.estimate.price_type == "tax_exclusive";
    },
    is_tax_inclusive() {
      return this.estimate.price_type == "tax_inclusive";
    },
    amount_due() {
      return this.estimate.amount_due;
    },
    total_credits() {
      return CartHelper.getTotalCreditsFromDiscounts(
        this.estimate.discounts,
        this.estimate.credits_applied,
        this.estimate.amount_paid
      );
    },
    getDiscountTooltipMessage() {
      return this.$store.getters.get_text('hp_v3.discount.tooltip_message');
    }
  },
  methods: {
    isManualDiscount(item) {
      return HostedPageHelper.isManualDiscount(item);
    }
  },
};
</script>